import { z } from 'zod';
import { accountBadgeResponseSchema } from '../schema/commonResponseSchema';
const updateAccountBadgeOptionsRequestSchema = z.object({
    accountBadgeId: z.string(),
    accountBadgeOptions: z
        .object({
        organizationId: z.string().uuid().optional(),
    })
        .passthrough(),
});
const updateAccountBadgeOptionsResponseSchema = z.object({
    accountBadge: accountBadgeResponseSchema,
});
export const updateAccountBadgeOptionsFunctionDef = {
    name: 'updateAccountBadgeOptions',
    requestSchema: updateAccountBadgeOptionsRequestSchema,
    responseSchema: updateAccountBadgeOptionsResponseSchema,
};
